<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12" sm="12">
          Campos marcados com o ícone <v-icon color="warning">mdi-alert-circle</v-icon> são obrigatórios para Emissão da MDFe 
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Descrição"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="4">
        <v-switch 
          v-model="entry.enabled" 
          inset 
          :label="entry.enabled ? 'Ativo' : 'Inativo'"
          :disabled="readOnly">
        </v-switch>
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.patrimonyCategoryId"
          v-bind="getObject('patrimonyCategoryId')"
          label="Categoria"
          :items="extraData.globalContext.allPatrimonyCategories"
          item-value="id"
          item-text="name"
          @input="selectPatrimonyCategory"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="entry.model"
          v-bind="getObject('model')"
          label="Modelo"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="entry.brandId"
          v-bind="getObject('brandId')"
          label="Marca"
          :items="extraData.accountGlobalSharedContext.allPatrimonyBrands"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:append-outer>
            <BrandNew
              :inlineAddButton="true"
              @entry-created="brandCreated"
              withType="patrimony"
              modelNameSingular="Marca de Patrimônio"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="entry.workingMetricType"
          v-bind="getObject('workingMetricType')"
          label="Métrica de Trabalho"
          :items="extraData.globalContext.allPatrimonyWorkingMetricTypes"
          item-value="value"
          item-text="text"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="6" sm="6" md="3" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind != 'agricultural_machinery' && entry.patrimonyCategory.kind != 'implements')">
        <v-text-field
          v-model="entry.plate"
          v-bind="getObject('plate')"
          label="Placa"
          autocomplete="off"
          :disabled="readOnly"
        >
        <template v-slot:append>
            <v-icon color="warning">mdi-alert-circle</v-icon>
          </template>
        </v-text-field>
        
        <!-- <MaskedTextField
          v-bind="getObject('plate')"
          :inputData.sync="entry.plate"
          mask-type="plate"
          label="Placa"
        /> -->
      </v-col>

      <v-col cols="6" sm="6" md="3" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind != 'agricultural_machinery' && entry.patrimonyCategory.kind != 'implements')">
        <v-autocomplete
          v-model="entry.plateStateId"
          v-bind="getObject('plateStateId')"
          label="UF Placa"
          :items="extraData.globalContext.allStates"
          item-value="id"
          item-text="shortName"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="6" sm="6" md="2">
        <MaskedTextField
          v-bind="getObject('year')"
          :inputData.sync="entry.year"
          mask-type="year"
          label="Ano"
          :key="yearKey"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="entry.chassi"
          v-bind="getObject('chassi')"
          label="Número do Chassi"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <MaskedTextField
          v-bind="getObject('price')"
          :inputData.sync="entry.price"
          mask-type="currency"
          label="Valor do Bem"
          prefix="R$"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <MaskedTextField
          v-bind="getObject('hourlyPrice')"
          :inputData.sync="entry.hourlyPrice"
          mask-type="currency"
          label="Preço por hora"
          prefix="R$"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind != 'implements')">
        <MaskedTextField
          v-bind="getObject('potency')"
          :inputData.sync="entry.potency"
          mask-type="currency"
          label="Potência"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind == 'agricultural_machinery' || entry.patrimonyCategory.kind == 'implements' || entry.patrimonyCategory.kind == 'others')">
        <v-text-field
          v-model="entry.serialNumber"
          v-bind="getObject('serialNumber')"
          label="Número de Série"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind == 'agricultural_machinery' || entry.patrimonyCategory.kind == 'others')">
        <v-text-field
          v-model="entry.motorNumber"
          v-bind="getObject('motorNumber')"
          label="Número do Motor"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field
          v-model="entry.insurancePolicyNumber"
          v-bind="getObject('insurancePolicyNumber')"
          label="Número da Apólice do Seguro"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <DateField
          :inputData.sync="entry.insuranceExpirationDate"
          v-bind="getObject('insuranceExpirationDate')"
          label="Data de Vencimento do Seguro"
          :hasTodayButton="true"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind != 'agricultural_machinery' && entry.patrimonyCategory.kind != 'implements')">
        <v-text-field
          v-model="entry.renavan"
          v-bind="getObject('renavan')"
          label="Renavan"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind == 'trucks' || entry.patrimonyCategory.kind == 'vehicles'  || entry.patrimonyCategory.kind == 'others' || entry.patrimonyCategory.kind == 'trailer' || entry.patrimonyCategory.kind == 'mechanical_horse')">
        <MaskedTextField
          v-bind="getObject('axesNumber')"
          :inputData.sync="entry.axesNumber"
          mask-type="integer"
          label="Número de Eixos"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind == 'trucks' || entry.patrimonyCategory.kind == 'others' || entry.patrimonyCategory.kind == 'trailer' || entry.patrimonyCategory.kind == 'vehicles')">
        <MaskedTextField
          v-bind="getObject('grossWeight')"
          :inputData.sync="entry.grossWeight"
          mask-type="currency"
          label="Peso Bruto"
          suffix="Kg"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind == 'trucks' || entry.patrimonyCategory.kind == 'vehicles'  || entry.patrimonyCategory.kind == 'others' || entry.patrimonyCategory.kind == 'trailer')">
        <MaskedTextField
          v-bind="getObject('loadCapacity')"
          :inputData.sync="entry.loadCapacity"
          mask-type="currency"
          label="Capacidade de Carga"
          suffix="Kg"
          autocomplete="off"
          :disabled="readOnly"
          :showAlertIcon="true"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind == 'trucks' || entry.patrimonyCategory.kind == 'vehicles'  || entry.patrimonyCategory.kind == 'others' || entry.patrimonyCategory.kind == 'trailer' || entry.patrimonyCategory.kind == 'mechanical_horse')">
        <MaskedTextField
          v-bind="getObject('tare')"
          :inputData.sync="entry.tare"
          mask-type="currency"
          label="Tara"
          suffix="Kg"
          autocomplete="off"
          :disabled="readOnly"
          :showAlertIcon="true"
        >
        </MaskedTextField>
      </v-col>

      <v-col cols="12" sm="12" md="6" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind == 'trucks' || entry.patrimonyCategory.kind == 'vehicles')">
        <v-autocomplete v-model="entry.wheeledType" v-bind="getObject('wheeledType')" label="Tipo Rodado"
          :items="extraData.globalContext.allWheeledTypes" item-value="id" item-text="name" autocomplete="off"
          :disabled="readOnly">
          <template v-slot:append>
            <v-icon color="warning">mdi-alert-circle</v-icon>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="6" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind == 'trucks' || entry.patrimonyCategory.kind == 'vehicles')">
        <v-autocomplete v-model="entry.bodyType" v-bind="getObject('bodyType')" label="Tipo Carroceria"
          :items="extraData.globalContext.allBodyTypes" item-value="id" item-text="name" autocomplete="off"
          :disabled="readOnly">
          <template v-slot:append>
            <v-icon color="warning">mdi-alert-circle</v-icon>
          </template>
        </v-autocomplete>
      </v-col>

       <v-col cols="12" sm="6" md="6" v-if="entry.patrimonyCategory && (entry.patrimonyCategory.kind == 'trucks' || entry.patrimonyCategory.kind == 'vehicles'  || entry.patrimonyCategory.kind == 'others' || entry.patrimonyCategory.kind == 'trailer' || entry.patrimonyCategory.kind == 'mechanical_horse')">
        <v-text-field
          v-model="entry.bodywork"
          v-bind="getObject('bodywork')"
          label="Carroceria"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.colorId"
          v-bind="getObject('colorId')"
          label="Cor"
          :items="extraData.globalContext.allColors"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:selection="data">
            <span>
              <v-icon right :color="data.item.hexaCode" class="mr-2">mdi-circle</v-icon>
              {{data.item.name}}
            </span>
            
          </template>
          <template v-slot:item="data">
            <span> 
              <v-icon right :color="data.item.hexaCode" class="mr-2">mdi-circle</v-icon>
              {{data.item.name}}
            </span>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.observation"
          v-bind="getObject('observation')"
          label="Observação"
          autocomplete="off"
          outlined
          :disabled="readOnly"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import BrandNew from "@models/brands/new.vue"
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      yearKey: 1,
       pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    BrandNew: BrandNew,
    BaseUtil: BaseUtil
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectPatrimonyCategory: function() {
      this.entry.patrimonyCategory = this.extraData.globalContext.allPatrimonyCategories.find(obj => obj.id == this.entry.patrimonyCategoryId);
      this.yearKey++;
    },
    brandCreated: function(brand) {
      if (brand.brandType == "patrimony") {
        this.extraData.accountGlobalSharedContext.allPatrimonyBrands.unshift(brand);
        this.entry.brandId = brand.id;
        this.entry.brand = brand;
      } else {
        this.$refs.util.showErrorMessage("A Marca cadastrada não é do tipo Patrimônio, por isso não irá aparecer na lista de marcas!");
      }
    },
  }
};
</script>

<style scoped></style>
